import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setIsShowTag } from '@interlayer/js/components/system/App/store/buzz/actions';
import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

export const useShowAction = (type: TAG_TYPE_BUZZ, isShow = true) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setIsShowTag(type, isShow));

        return () => {
            dispatch(setIsShowTag(type, false));
        };
    }, [dispatch, isShow, type]);
};
